/* REL Wholesale theme JS — no dependencies. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var fmt = (window.REL && window.REL.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  /* Quantity stepper respecting min (MOQ) and step (case pack) */
  if (!customElements.get('quantity-stepper')) {
    customElements.define('quantity-stepper', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => this.bump(parseInt(b.dataset.dir, 10))));
        this.input.addEventListener('change', () => this.snap());
      }
      bump(dir) {
        var step = parseInt(this.input.step, 10) || 1;
        var min = parseInt(this.input.min, 10);
        var val = parseInt(this.input.value, 10) || 0;
        var next = val + dir * step;
        if (!isNaN(min) && next < min) next = dir < 0 && this.input.hasAttribute('data-allow-zero') ? 0 : min;
        if (next < 0) next = 0;
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      showMsg(text) {
        /* Message goes in its own block, never inside the stepper's flex row:
           cart -> the line's error slot (info column); product -> below the buy row; quick order -> below the stepper. */
        var row = this.closest('.cart-item');
        var slot = row && row.querySelector('[data-line-error]');
        if (slot) { slot.textContent = text || ''; slot.hidden = !text; return; }
        if (!this._msg) {
          if (!text) return;
          var m = document.createElement('p'); m.className = 'qty__msg'; m.setAttribute('role', 'status');
          var anchor = this.closest('.buy-row') || this;
          anchor.insertAdjacentElement('afterend', m);
          this._msg = m;
        }
        this._msg.textContent = text || ''; this._msg.hidden = !text;
      }
      snap() {
        var rawv = String(this.input.value).trim();
        if ((rawv === '' || isNaN(parseInt(rawv, 10)) || parseInt(rawv, 10) < 0) && this.input.dataset.prev != null) { this.input.value = this.input.dataset.prev; return; }
        var step = parseInt(this.input.step, 10) || 1;
        var min = parseInt(this.input.min, 10) || 0;
        var val = parseInt(this.input.value, 10) || 0;
        if (val === 0 && this.input.hasAttribute('data-allow-zero')) return;
        if (val < min) val = min;
        var max = parseInt(this.input.max, 10);
        if (max > 0 && val > max) { val = max; this.showMsg('Maximum ' + max + ' per line.'); }
        else if (!(max > 0 && val === max)) this.showMsg('');
        if (step > 1 && val % step !== 0) val = Math.ceil(val / step) * step;
        if (String(val) !== this.input.value) this.input.value = val;
      }
    });
  }

  /* Mobile menu drawer */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-drawer-open'));
      if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-drawer-close]')) {
      document.querySelectorAll('.drawer.is-open,.filters.is-open').forEach(function (d) { d.classList.remove('is-open'); });
      document.body.style.overflow = '';
    }
    var ft = e.target.closest('[data-filters-toggle]');
    if (ft) { var f = document.getElementById(ft.getAttribute('data-filters-toggle')); if (f) f.classList.add('is-open'); }
  });

  /* Menu drawer lives inside the sticky header (backdrop-filter makes it the containing block for position:fixed),
     so move it to <body> to get a true full-height overlay. */
  document.querySelectorAll('.header .drawer').forEach(function (d) { document.body.appendChild(d); });

  /* Escape closes the menu drawer / mobile filters */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.drawer.is-open,.filters.is-open');
    if (!open.length) return;
    open.forEach(function (d) { d.classList.remove('is-open'); });
    document.body.style.overflow = '';
  });

  /* Collection filters: auto-submit on change */
  document.querySelectorAll('form[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox], select')) form.submit();
    });
  });
  document.querySelectorAll('select[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-media-id]');
      if (!t || !t.classList.contains('gallery__thumb')) return;
      showMedia(g, t.dataset.mediaId);
    });
  });
  function showMedia(g, id) {
    g.querySelectorAll('.gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === String(id)); });
    g.querySelectorAll('.gallery__thumb').forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === String(id)); });
  }

  /* Weight (grams) — matches relintlny.com: "24.6 g", "1.25 kg" at 1000g+ */
  function formatGrams(g) {
    g = Number(g) || 0;
    if (g <= 0) return '—';
    return g >= 1000 ? (g / 1000).toFixed(2) + ' kg' : g.toFixed(1) + ' g';
  }
  window.REL = window.REL || {}; window.REL.formatGrams = formatGrams;
  function updateProductWeight(root) {
    var box = root.querySelector('[data-weight-total-box]');
    if (!box) return;
    var per = Number(root.dataset.grams) || 0;
    var qi = root.querySelector('form input[name="quantity"]');
    var q = qi ? (parseInt(qi.value, 10) || 0) : 1;
    box.hidden = per <= 0;
    var v = box.querySelector('[data-weight-total]'); if (v) v.textContent = formatGrams(per * q);
    var c = box.querySelector('[data-weight-calc]'); if (c) c.textContent = q + ' pcs \u00d7 ' + per + 'g';
  }
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('script[data-product-json]');
    if (json) {
      try {
        var p = JSON.parse(json.textContent);
        var idEl = root.querySelector('input[name="id"]');
        var m = idEl && (p.variant_meta || {})[idEl.value];
        if (m) root.dataset.grams = m.weight || 0;
      } catch (e) {}
    }
    var onQty = function (e) { if (e.target.matches('input[name="quantity"]')) updateProductWeight(root); };
    root.addEventListener('input', onQty); root.addEventListener('change', onQty);
    updateProductWeight(root);
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('script[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var canBuy = root.dataset.canBuy === 'true';
    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option]')) return;
      var selected = Array.from(root.querySelectorAll('[data-option]')).map(function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
      if (!v) return;
      root.querySelector('input[name="id"]').value = v.id;
      var set = function (sel, val) { var el = root.querySelector(sel); if (el) el.textContent = val; };
      root.querySelectorAll('[data-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked'), l = fs.querySelector('.option__label .muted');
        if (c && l) l.textContent = c.value;
      });
      set('[data-sku]', v.sku || '—');
      var meta = (product.variant_meta || {})[v.id] || {};
      set('[data-weight]', meta.weight ? meta.weight + 'g' : '—');
      root.dataset.grams = meta.weight || 0;
      updateProductWeight(root);
      set('[data-length]', meta.length || v.option1 || '—');
      if (canBuy) set('[data-price]', formatMoney(v.price));
      var btn = root.querySelector('[data-add]');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout; }
      if (v.featured_media) { var g = document.querySelector('[data-gallery]'); if (g) showMedia(g, v.featured_media.id); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    });
  });

  /* Cart count helper */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    });
  }

  /* Quick order / bulk add */
  document.querySelectorAll('[data-quick-order]').forEach(function (root) {
    var search = root.querySelector('[data-qo-search]');
    var rows = Array.from(root.querySelectorAll('tbody tr[data-variant-id]'));
    var totalEl = root.querySelector('[data-qo-total]');
    var countEl = root.querySelector('[data-qo-count]');
    var status = root.querySelector('[data-qo-status]');
    function recalc() {
      var total = 0, count = 0;
      rows.forEach(function (r) {
        var inp = r.querySelector('input'); if (!inp) return;
        var q = Math.max(0, parseInt(inp.value, 10) || 0);
        r.classList.toggle('has-qty', q > 0);
        count += q; total += q * (parseInt(r.dataset.price, 10) || 0);
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (countEl) countEl.textContent = count;
      var sb = root.querySelector('[data-qo-submit]'); if (sb && !sb.dataset.busy) sb.disabled = count === 0;
      if (count > 0 && status && !(sb && sb.dataset.busy)) status.textContent = '';
    }
    root.addEventListener('change', recalc);
    root.addEventListener('input', recalc);
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      rows.forEach(function (r) { r.classList.toggle('is-hidden', q && r.dataset.search.indexOf(q) === -1); });
    });
    var btn = root.querySelector('[data-qo-submit]');
    if (btn) btn.addEventListener('click', function () {
      var items = rows.map(function (r) {
        var inp = r.querySelector('input');
        return { id: parseInt(r.dataset.variantId, 10), quantity: inp ? Math.max(0, parseInt(inp.value, 10) || 0) : 0 };
      }).filter(function (i) { return i.quantity > 0; });
      if (!items.length) { status.textContent = 'Enter a quantity for at least one item.'; return; }
      btn.disabled = true; btn.dataset.busy = '1'; status.textContent = 'Adding ' + items.length + ' line(s) to cart…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          delete btn.dataset.busy; btn.disabled = false;
          if (!res.ok) { status.textContent = res.j.description || 'Could not add items.'; return; }
          status.innerHTML = 'Added to cart. <a class="link-strong" href="/cart" style="color:#fff">Review cart &rarr;</a>';
          rows.forEach(function (r) { var inp = r.querySelector('input'); if (inp) inp.value = 0; }); recalc(); refreshCount();
        })
        .catch(function () { delete btn.dataset.busy; btn.disabled = false; status.textContent = 'Network error. Please try again.'; });
    });
    recalc();
  });

  /* Cart: live weight per line + total */
  function updateCartWeight(form) {
    var total = 0;
    form.querySelectorAll('.cart-item[data-grams]').forEach(function (row) {
      var g = Number(row.dataset.grams) || 0;
      var qi = row.querySelector('.qty__input');
      var q = qi ? (parseInt(qi.value, 10) || 0) : 0;
      total += g * q;
      var lw = row.querySelector('[data-line-weight]'); if (lw) lw.textContent = formatGrams(g * q);
      var lc = row.querySelector('[data-line-calc]'); if (lc) lc.textContent = '(' + q + ' \u00d7 ' + g + 'g)';
    });
    document.querySelectorAll('[data-cart-weight]').forEach(function (el) { el.textContent = formatGrams(total); });
  }
  document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
    var h = function (e) { if (e.target.matches('.qty__input')) updateCartWeight(form); };
    form.addEventListener('input', h); form.addEventListener('change', h);
    updateCartWeight(form);
  });

  /* Cart: AJAX quantity updates (Cart API /cart/change.js), no page reload */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
    var wrap = form.closest('[id^="shopify-section-"]');
    var sectionId = wrap ? wrap.id.replace('shopify-section-', '') : null;
    var queue = Promise.resolve();
    form.querySelectorAll('.qty__input').forEach(function (i) { i.dataset.prev = i.value; });
    var upd = form.querySelector('[name=update]'); if (upd) upd.hidden = true;

    function lineError(row, msg) {
      var el = row && row.querySelector('[data-line-error]');
      if (!el) return;
      el.textContent = msg || ''; el.hidden = !msg;
    }
    function applySectionHtml(html) {
      if (!html || !wrap) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-min-notice]'), cur = form.querySelector('[data-min-notice]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var fb = doc.querySelector('[data-checkout]'), cb = form.querySelector('[data-checkout]');
      if (fb && cb) cb.disabled = fb.disabled;
    }
    function apply(cart, row, html) {
      setCount(cart.item_count);
      if (cart.item_count === 0 && !html) return;
      if (cart.item_count === 0 && html && wrap) {   /* empty-cart state from Shopify's own render */
        var d = new DOMParser().parseFromString(html, 'text/html');
        var inner = d.querySelector('[id^="shopify-section-"]') || d.body;
        wrap.innerHTML = inner.innerHTML; return;
      }
      var byKey = {}, byVariant = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; (byVariant[it.variant_id] = byVariant[it.variant_id] || []).push(it); });
      form.querySelectorAll('.cart-item[data-key]').forEach(function (r) {
        var it = byKey[r.dataset.key];
        if (!it && r.dataset.variant && byVariant[r.dataset.variant] && byVariant[r.dataset.variant].length === 1) {
          it = byVariant[r.dataset.variant][0]; r.dataset.key = it.key;   /* line key changed server-side */
        }
        if (!it) {
          r.style.transition = 'opacity .25s'; r.style.opacity = '0';
          setTimeout(function () { r.remove(); updateCartWeight(form); }, 250);
          return;
        }
        var qi = r.querySelector('.qty__input');
        if (qi && document.activeElement !== qi) qi.value = it.quantity;
        if (qi) qi.dataset.prev = it.quantity;
        var lp = r.querySelector('[data-line-price]');
        if (lp && lp.textContent.trim() !== '') lp.textContent = formatMoney(it.final_line_price);
      });
      var items = form.querySelector('[data-cart-items]'); if (items) items.textContent = cart.item_count;
      var sub = form.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = formatMoney(cart.total_price);
      updateCartWeight(form);
      applySectionHtml(html);
    }
    var pending = 0;
    function post(url, body) {
      var ctl = window.AbortController ? new AbortController() : null;
      var to = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : null;
      return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, signal: ctl ? ctl.signal : undefined, credentials: 'same-origin' })
        .then(function (r) { clearTimeout(to); return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: false, j: {} }; }); })
        .catch(function (err) { clearTimeout(to); throw err; });
    }
    function sectionHtml() {
      if (!sectionId) return Promise.resolve(null);
      var u = new URL(window.location.href); u.searchParams.set('section_id', sectionId);   /* keeps preview_theme_id */
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; });
    }
    /* After the queue drains, re-sync everything from the server (cart.js + section render). */
    function reconcile() {
      /* The section render is only needed for the order-minimum notice / checkout state, or the empty-cart screen. */
      var needSection = form.dataset.minActive !== 'false';
      return post('/cart.js').then(function (c) {
        if (!c.ok) return;
        if (!needSection && c.j.item_count > 0) { apply(c.j, null, null); return; }
        return sectionHtml().then(function (html) { apply(c.j, null, html); });
      }).catch(function () {});
    }
    function change(row, qty) {
      var key = row.dataset.key;   /* line item KEY, never an index */
      var qi = row.querySelector('.qty__input');
      var prev = qi ? qi.dataset.prev : null;
      row.classList.add('is-updating');
      if (qty === 0) row.dataset.removing = '1';
      pending++;
      queue = queue.then(function () {
        return post('/cart/change.js', { id: key, quantity: qty }).then(function (res) {
          row.classList.remove('is-updating');
          if (!res.ok) {
            delete row.dataset.removing;
            if (qi && prev != null) qi.value = prev;
            lineError(row, res.j.description || res.j.message || 'Could not update quantity.');
            updateCartWeight(form);
            return;
          }
          apply(res.j, row, null);
        }, function () {
          row.classList.remove('is-updating'); delete row.dataset.removing;
          if (qi && prev != null) qi.value = prev;
          lineError(row, 'Network error. Please try again.');
          updateCartWeight(form);
        });
      }).then(function () {
        pending--;
        if (pending === 0) return reconcile();
      });
    }
    var timers = {};
    form.addEventListener('change', function (e) {
      if (!e.target.matches('.qty__input')) return;
      var row = e.target.closest('.cart-item[data-key]'); if (!row || row.dataset.removing) return;
      var raw = String(e.target.value).trim();
      var q = parseInt(raw, 10);
      if (raw === '' || isNaN(q) || q < 0) {   /* empty / invalid input: restore, don't remove the line */
        e.target.value = e.target.dataset.prev || 1; updateCartWeight(form); return;
      }
      if (String(q) === String(e.target.dataset.prev)) { clearTimeout(timers[row.dataset.key]); updateCartWeight(form); return; }
      clearTimeout(timers[row.dataset.key]);
      timers[row.dataset.key] = setTimeout(function () { change(row, q); }, 350);
    });
    form.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]'); if (!rm) return;
      var row = rm.closest('.cart-item[data-key]');
      e.preventDefault();
      if (!row || row.dataset.removing) return;
      var qi = row.querySelector('.qty__input'); if (qi) qi.value = 0;
      updateCartWeight(form);
      change(row, 0);
    });
    form.addEventListener('keydown', function (e) {   /* Enter in qty field: don't submit/reload */
      if (e.key === 'Enter' && e.target.matches('.qty__input')) { e.preventDefault(); e.target.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  /* Product page: Add to order via /cart/add.js (falls back to normal submit if JS fails) */
  document.querySelectorAll('form[id^="ProductForm"]').forEach(function (pf) {
    pf.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = pf.querySelector('[data-add]');
      var msg = pf.querySelector('[data-add-status]');
      if (!msg) { msg = document.createElement('p'); msg.className = 'add-status'; msg.setAttribute('data-add-status', ''); msg.setAttribute('role', 'status'); (pf.querySelector('.buy-row') || pf).insertAdjacentElement('afterend', msg); }
      if (btn) btn.disabled = true;
      msg.className = 'add-status'; msg.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(pf) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (btn) btn.disabled = false;
          if (!res.ok) { msg.className = 'add-status is-error'; msg.textContent = res.j.description || res.j.message || 'Could not add to order.'; return; }
          var qIn = pf.querySelector('input[name="quantity"]');
          var q = qIn ? (parseInt(qIn.value, 10) || 1) : 1;
          var vt = res.j.variant_title && res.j.variant_title !== 'Default Title' ? res.j.variant_title : (res.j.product_title || 'Item');
          msg.textContent = 'Added: ' + vt + ' \u00d7 ' + q + ' \u2014 ';
          var a = document.createElement('a'); a.className = 'link-strong'; a.href = '/cart'; a.textContent = 'View cart'; msg.appendChild(a);
          refreshCount();
        })
        .catch(function () { if (btn) btn.disabled = false; msg.className = 'add-status is-error'; msg.textContent = 'Network error. Please try again.'; });
    });
  });
})();
